import { nanoid } from 'nanoid';

export default {

  setFormType(state, formType) {
    state.form.type = formType;
  },

  setFormQuestions(state, formQuestions) {
    let questions = formQuestions;

    if (state.form.type === 'static') {
      // An index property is used for the correct drag and drop reordering in static forms
      questions = formQuestions.map((question, index) => ({
        ...question,
        index,
      }));
    } else {
      // Dynamic forms use a vuexId in each question to map questions to different screens
      questions = formQuestions.map((question, index) => {
        if (question.vuexId === undefined) {
          return { ...question, vuexId: nanoid(), index };
        }
        return { ...question, index };
      });
    }

    state.form.questions = questions;
  },

  updateSelectedQuestion(state, question) {
    state.selectedQuestion = question;

    if (state.form.type === 'dynamic') {
      state.form.questions.splice(state.currentScreen - 1, 1, question);
      return;
    }

    if (!question.non_question) {
      state.form.questions[question.index] = question;
    }
  },

  setFormScreens(state) {
    state.screens = [];

    state.form.questions.forEach((question, index) => {
      state.screens.splice(index, 0, {
        number: index + 1,
        questionVuexId: question.vuexId,
        layout: question.layout || { type: 'text-only' },
      });
    });
  },

  reorderFormScreens(state, screens) {
    state.screens = screens;
    const questions = [];
    state.screens.forEach((screen) => {
      questions.push(state.form.questions.filter((question) => question.vuexId === screen.questionVuexId)[0]);
    });

    state.form.questions = questions;
  },

  addFormScreen(state, currentScreeNumber) {
    state.screens.splice(currentScreeNumber, 0, {
      number: currentScreeNumber + 1,
      questionVuexId: null,
      layout: { type: 'text-only' },
    });

    // Re-index the screen numbers
    state.screens.forEach((screen, index) => {
      screen.number = index + 1; // eslint-disable-line
    });

    state.currentScreen += 1;
  },

  setCurrentScreenNumber(state, number) {
    state.currentScreen = number;
  },

  setScreenLayoutType(state, layoutType) {
    const currentScreen = state.screens[state.currentScreen - 1];
    currentScreen.layout.type = layoutType;

    const selectedQuestion = { ...state.form.questions[state.currentScreen - 1] };
    selectedQuestion.layout = { ...selectedQuestion.layout, type: layoutType };

    state.form.questions.splice(state.currentScreen - 1, 1, selectedQuestion);
  },

  incrementCurrentFormScreen(state) {
    state.currentScreen += 1;
  },

  decrementCurrentFormScreen(state) {
    state.currentScreen -= 1;
  },

  deleteFormScreen(state, screenToDelete) {
    // Called from removeDynamicFormScreen action. Always call the action to remove question from the event as well as the screen
    if (state.screens.length > 1) {
      state.screens.splice(screenToDelete.number - 1, 1);

      // Re-index the screen numbers
      state.screens.forEach((screen, index) => {
        screen.number = index + 1; // eslint-disable-line
      });
    }
  },

  removeQuestionFromScreen(state, questionToRemove) {
    state.screens = state.screens.map((screen) => {
      if (screen.questionVuexId === questionToRemove.vuexId) {
        return {
          ...screen,
          questionVuexId: null,
          layout: { type: 'text-only' },
        };
      }
      return screen;
    });
  },

  addQuestionToScreen(state, { screenNumber, question }) {
    const screenIndex = screenNumber - 1;

    state.screens.splice(screenIndex, 1, {
      ...state.screens[screenIndex],
      number: screenNumber,
      questionVuexId: question.vuexId,
    });

    state.form.questions.splice(screenIndex, 0, question);
  },

  updateLogicWarnings(state, warning) {
    state.logicWarningsShown[warning] = true;
  },

  /*
  * Current question indicates if a question is being modified or not in the question builder panel
  * resetSelectedQuestion can be used to hide the question editor panel
   */
  resetSelectedQuestion(state) {
    state.selectedQuestion = {
      id: null,
      vuexId: null,
      number: null,
      layout: null,
      alignment: null,
    };
  },
};
